import React from 'react';
import { StatusIcon } from './helper';
import FieldIcon from '../../b2b-common/FieldIcon';
import useB2BTranslation from '../../b2b-common/hooks/useB2BTranslation';

const Status = ({ status, className = null, showLabel = true, withTooltip = true }) => {
    const { t } = useB2BTranslation('b2b-plans');
    return (
        <FieldIcon label={showLabel ? t('Status') : null} icon={<StatusIcon status={status} withTooltip={withTooltip} />} className={className} />
    );
};

export default Status;